export function parseAcapsPopulation(value: unknown): number | null {
    if (typeof value !== 'number' && (typeof value !== 'string' || !value.trim()))
        return null;
    const population = Number(value);
    return Number.isFinite(population) && population >= 0 ? population : null;
}
